// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item[data-v-0e1e115c]{margin-top:5px;margin-right:5px;margin-bottom:5px;margin-left:5px}\n", ""]);
// Exports
module.exports = exports;
